// components/YandexMetrika.jsx
import React, { useEffect } from 'react';

const YandexMetrika = () => {
  useEffect(() => {
    const loadMetrika = () => {
      document.removeEventListener('mousemove', loadMetrika);
      document.removeEventListener('touchstart', loadMetrika);

      // Загружаем Яндекс.Метрику только если её ещё нет
      if (window.ym) return;

      (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
      m[i].l=1*new Date();
      k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
      (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

      ym(104446038, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true,
        ecommerce:"dataLayer"
      });
    };

    document.addEventListener('mousemove', loadMetrika, { once: true });
    document.addEventListener('touchstart', loadMetrika, { once: true });

    return () => {
      document.removeEventListener('mousemove', loadMetrika);
      document.removeEventListener('touchstart', loadMetrika);
    };
  }, []);

  return (
    <noscript>
      <div>
        <img
          src="https://mc.yandex.ru/watch/104446038"
          style={{ position: 'absolute', left: '-9999px' }}
          alt=""
        />
      </div>
    </noscript>
  );
};

export default YandexMetrika;
